function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "17. Bus");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_17._Bus",
  "data-name": "17. Bus"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M48,17a5,5,0,0,0-5-5H3a3,3,0,0,0-3,3V29a3,3,0,0,0,3,3H6.1a5,5,0,0,0,9.8,0H32.1a5,5,0,0,0,9.8,0H45a3,3,0,0,0,3-3C48,28.13,48,32.76,48,17Zm-2,9H45a1,1,0,0,1,0-2h1Zm-.86-11.12A3.76,3.76,0,0,1,46,18H40V14C42.78,14,44,13.75,45.12,14.88ZM33,18V14h5v4ZM13,18V14h6v4Zm8-4h6v4H21ZM11,14v4H6l0-4ZM2,24H3.83A3,3,0,0,1,2,25.83Zm9,10a3,3,0,1,1,3-3A3,3,0,0,1,11,34Zm26,0a3,3,0,1,1,3-3A3,3,0,0,1,37,34Zm8-4H41.9a5,5,0,0,0-9.8,0H15.9a5,5,0,0,0-9.8,0H3a1,1,0,0,1-1-1V27.9C5.91,27.1,7.08,22,5,22H2V15a1,1,0,0,1,1-1H4l0,4a2,2,0,0,0,2,2H28a1,1,0,0,0,1-1V14h2v5a1,1,0,0,0,1,1H46v2H45a3,3,0,0,0,0,6h1v1A1,1,0,0,1,45,30Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M37.68,30.29A1,1,0,1,0,37,32,1,1,0,0,0,37.68,30.29Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M11.68,30.29a1,1,0,1,0,0,1.42A1,1,0,0,0,11.68,30.29Z"
}));

var SvgBus2 = function SvgBus2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBus2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bus2.013c5c32.svg";
export { ForwardRef as ReactComponent };